import Vue from 'vue' // 引入vue
// 第一个参数表示从哪个文件夹开始匹配 这里表示从当前文件夹开始
// 第二个参数表示是否匹配子文件夹中的内容
// 第三个参数表示要匹配的文件的类型 这里匹配vue文件
let requireComponent = require.context(
  './', // 在当前目录下查找
  false, // 不遍历子文件夹
  /\.vue$/ // 正则匹配 以 .vue结尾的文件
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  // 注册组件名称
  Vue.component(fileName.replace(/^\.\/(.*)\.\w+$/, '$1'), componentConfig.default || componentConfig)
})
